var endpointMap = {
	ar: {
		PublicNoticeForm: "translation-ar.json"
	},
	"ar-AE": {
		PublicNoticeForm: "translation-ar.json"
	},
	bn: {
		PublicNoticeForm: "translation-bn.json"
	},
	"bn-IN": {
		PublicNoticeForm: "translation-bn.json"
	},
	cs: {
		PublicNoticeForm: "translation-cs.json"
	},
	"cs-CZ": {
		PublicNoticeForm: "translation-cs.json"
	},
	da: {
		PublicNoticeForm: "translation-da.json"
	},
	"da-DK": {
		PublicNoticeForm: "translation-da.json"
	},
	de: {
		PublicNoticeForm: "translation-de.json"
	},
	"de-DE": {
		PublicNoticeForm: "translation-de.json"
	},
	en: {
		PublicNoticeForm: "translation-en.json"
	},
	"en-AE": {
		PublicNoticeForm: "translation-en.json"
	},
	"en-AU": {
		PublicNoticeForm: "translation-en.json"
	},
	"en-CA": {
		PublicNoticeForm: "translation-en.json"
	},
	"en-GB": {
		PublicNoticeForm: "translation-en.json"
	},
	"en-IE": {
		PublicNoticeForm: "translation-en.json"
	},
	"en-IN": {
		PublicNoticeForm: "translation-en.json"
	},
	"en-SG": {
		PublicNoticeForm: "translation-en.json"
	},
	"en-US": {
		PublicNoticeForm: "translation-en.json"
	},
	"en-ZA": {
		PublicNoticeForm: "translation-en.json"
	},
	es: {
		PublicNoticeForm: "translation-es.json"
	},
	"es-ES": {
		PublicNoticeForm: "translation-es.json"
	},
	"es-MX": {
		PublicNoticeForm: "translation-es.json"
	},
	"es-US": {
		PublicNoticeForm: "translation-es.json"
	},
	fr: {
		PublicNoticeForm: "translation-fr.json"
	},
	"fr-BE": {
		PublicNoticeForm: "translation-fr.json"
	},
	"fr-CA": {
		PublicNoticeForm: "translation-fr.json"
	},
	"fr-FR": {
		PublicNoticeForm: "translation-fr.json"
	},
	he: {
		PublicNoticeForm: "translation-he.json"
	},
	"he-IL": {
		PublicNoticeForm: "translation-he.json"
	},
	hi: {
		PublicNoticeForm: "translation-hi.json"
	},
	"hi-IN": {
		PublicNoticeForm: "translation-hi.json"
	},
	id: {
		PublicNoticeForm: "translation-id.json"
	},
	"id-ID": {
		PublicNoticeForm: "translation-id.json"
	},
	it: {
		PublicNoticeForm: "translation-it.json"
	},
	"it-IT": {
		PublicNoticeForm: "translation-it.json"
	},
	ja: {
		PublicNoticeForm: "translation-ja.json"
	},
	"ja-JP": {
		PublicNoticeForm: "translation-ja.json"
	},
	kn: {
		PublicNoticeForm: "translation-kn.json"
	},
	"kn-IN": {
		PublicNoticeForm: "translation-kn.json"
	},
	ko: {
		PublicNoticeForm: "translation-ko.json"
	},
	"ko-KR": {
		PublicNoticeForm: "translation-ko.json"
	},
	ml: {
		PublicNoticeForm: "translation-ml.json"
	},
	"ml-IN": {
		PublicNoticeForm: "translation-ml.json"
	},
	mr: {
		PublicNoticeForm: "translation-mr.json"
	},
	"mr-IN": {
		PublicNoticeForm: "translation-mr.json"
	},
	nl: {
		PublicNoticeForm: "translation-nl.json"
	},
	"nl-BE": {
		PublicNoticeForm: "translation-nl.json"
	},
	"nl-NL": {
		PublicNoticeForm: "translation-nl.json"
	},
	pl: {
		PublicNoticeForm: "translation-pl.json"
	},
	"pl-PL": {
		PublicNoticeForm: "translation-pl.json"
	},
	pt: {
		PublicNoticeForm: "translation-pt.json"
	},
	"pt-BR": {
		PublicNoticeForm: "translation-pt.json"
	},
	"pt-PT": {
		PublicNoticeForm: "translation-pt.json"
	},
	sv: {
		PublicNoticeForm: "translation-sv.json"
	},
	"sv-SE": {
		PublicNoticeForm: "translation-sv.json"
	},
	ta: {
		PublicNoticeForm: "translation-ta.json"
	},
	"ta-IN": {
		PublicNoticeForm: "translation-ta.json"
	},
	te: {
		PublicNoticeForm: "translation-te.json"
	},
	"te-IN": {
		PublicNoticeForm: "translation-te.json"
	},
	th: {
		PublicNoticeForm: "translation-th.json"
	},
	"th-TH": {
		PublicNoticeForm: "translation-th.json"
	},
	tr: {
		PublicNoticeForm: "translation-tr.json"
	},
	"tr-TR": {
		PublicNoticeForm: "translation-tr.json"
	},
	und: {
		PublicNoticeForm: "translation.json"
	},
	zh: {
		PublicNoticeForm: "translation-zh.json"
	},
	"zh-CN": {
		PublicNoticeForm: "translation-zh.json"
	},
	"zh-TW": {
		PublicNoticeForm: "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
